<script>
  import { Button } from "paxray-components-svelte";

  export let previousText = "Previous task";
  export let nextText = "Next 10";
  export let previousDisabled = false;
  export let nextDisabled = false;
  export let onMarkShown = () => {};
  export let onPrevious = () => {};
  export let onNext = () => {};
  // Bulk checking only for a page short enough to have been read, larger pages are for browsing
  export let shownCount = 0;
  const MARK_SHOWN_LIMIT = 20;
</script>

<div class="pagination-actions">
  {#if shownCount <= MARK_SHOWN_LIMIT}
    <Button
      text="Mark shown as checked"
      kind="secondary"
      size="field"
      on:click={onMarkShown}
    />
  {/if}
  <Button
    text={previousText}
    kind="secondary"
    size="field"
    disabled={previousDisabled}
    on:click={onPrevious}
  />
  <Button
    text={nextText}
    kind="secondary"
    size="field"
    disabled={nextDisabled}
    on:click={onNext}
  />
</div>

<style>
  /* Stays at the bottom of the view, so the buttons do not move with the page length */
  .pagination-actions {
    position: sticky;
    bottom: 0;
    z-index: 1;
    padding: 0.5rem 0;
    background: var(--pax-white);
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--control-gap);
  }
</style>
